import * as yup from 'yup'

import { USAGE_AREA, LISTING_TYPE } from '@/modules/realestate/constants/realestate.const'

export const schemaListing = yup.object({
  real_estate_id: yup.string().required('Vui lòng chọn BDS'),
  map_sheet_number: yup.string().required('Vui lòng nhập số tờ'),
  plot_number: yup.string().required('Vui lòng nhập số thửa'),

  title: yup.string().required('Vui lòng nhập tên bất động sản'),
  description: yup
    .string()
    .required('Vui lòng nhập mô tả bất động sản')
    .max(1500, 'Mô tả không được quá 1500 ký tự'),

  // transaction_type: yup.array().min(1, 'Vui lòng chọn loại hình'),
  listing_type: yup.object().test('required', 'Vui lòng chọn loại tin', function (value) {
    return value?.code
  }),
  processing_status: yup.object().test('required', 'Vui lòng chọn trạng thái', function (value) {
    return value?.code
  }),
  real_estate_category: yup.object().test('required', 'Vui lòng chọn loại BDS', function (value) {
    return value?.code
  }),
  direction: yup.object().test('required', 'Vui lòng chọn hướng', function (value) {
    return value?.code
  }),
  price: yup.string().required('Vui lòng nhập giá'),
  area: yup
    .string()
    .when('real_estate_category', {
      is: (value: any) => !USAGE_AREA.includes(value?.[0]),
      then: (schema) => schema.required('Vui lòng nhập diện tích'),
    })
    .when('real_estate_category', {
      is: (value: any) => USAGE_AREA.includes(value?.[0]),
      then: (schema) => schema.required('Vui lòng nhập diện tích đất'),
    }),
  // usage_area: yup.string().when('real_estate_category', {
  //   is: (value: any) => USAGE_AREA.includes(value?.[0]),
  //   then: (schema) => schema.required('Vui lòng nhập diện tích sử dụng'),
  // }),
  photos: yup.array().min(3, 'Vui lòng chọn ít nhất 3 ảnh'),
  contract_id: yup
    .string()
    .nullable()
    .when('listing_type', {
      is: (value: any) => [LISTING_TYPE.EXCLUSIVE, LISTING_TYPE.OWNER].includes(value?.code),
      then: () => yup.string().required('Vui lòng chọn hợp đồng'),
      otherwise: () => yup.string().nullable(),
    }),
})

export const schemaAssetHistory = yup.object({
  type: yup.mixed().test('required', 'Trường dữ liệu là bắt buộc', function (value) {
    if (!value) return false
    return true
  }),
  value: yup.string().required('Trường giá trị là bắt buộc'),
  title: yup
    .string()
    .nullable()
    .when('type', {
      is: (val: any) => {
        return val?.code === 'price'
      },
      then: () => yup.string().required('Tiêu đề là bắt buộc'),
      otherwise: () => yup.string().nullable(),
    }),
})
